import React from 'react'

const MonitoringSkeleton = () => {
    return (
        <div className="bg-containerGray max-w-[357px] rounded-[10px] w-full h-full p-[35px] action-widget-card relative animate-pulse">
            {/* Header section */}
            <div>
                <div className="h-6 bg-lightBG rounded w-[40%] mb-2 opacity-50"></div>
                <div className="h-10 bg-lightBG rounded w-[80%] mb-4 opacity-50"></div>
            </div>

            {/* Dropdown section */}
            <div className="flex items-center justify-between mt-[25px]">
                <div className="flex flex-col bg-lightBG min-w-[180px] rounded-3xl relative mr-[5px] w-full max-w-[220px] opacity-50">
                    <div className="px-[15px] flex flex-row items-center justify-between w-full h-[40px] bg-lightBG rounded-full gap-[6px]">
                        <div className="h-4 bg-white rounded w-[70%] opacity-70"></div>
                        <div className="w-4 h-4 bg-white rounded opacity-70"></div>
                    </div>
                </div>
            </div>

            {/* Main content section */}
            <div className="flex flex-row items-center mt-[45px]">
                <div className="flex flex-row bg-white rounded-full justify-between items-center flex-1 p-[8px]">
                    {/* Emotion icons */}
                    <div className="flex items-center flex-wrap gap-[5px] flex-1">
                        {Array.from({ length: 7 }).map((_, index) => (
                            <div key={index} className="w-[20px] h-[20px] bg-lightBG rounded-full opacity-50" />
                        ))}
                    </div>

                    {/* Donut chart placeholder */}
                    <div className="w-[35px] h-[35px] bg-lightBG rounded-full opacity-50 mx-4"></div>

                    {/* Trend indicator */}
                    <div className="mr-[2px] flex flex-col items-center">
                        <div className="w-[27px] h-[27px] bg-lightBG rounded-full opacity-50 mb-1"></div>
                        <div className="w-[30px] h-3 bg-lightBG rounded opacity-50"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MonitoringSkeleton
